'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgWrapper = require('../../../core/SvgWrapper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var HandymanIcon = function HandymanIcon(props) {
  return React__default["default"].createElement(SvgWrapper, _objectSpread({}, props), React__default["default"].createElement("g", {
    id: "onboarding-/-industry-/-handyman",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React__default["default"].createElement("path", {
    d: "M29.6333111,24.8858818 L18.0687959,13.2512628 C19.2125391,10.3106449 18.5771262,6.85861508 16.1625571,4.42940893 C13.6209054,1.87234982 9.80842788,1.360938 6.75844585,2.76732051 L12.222997,8.26499759 L8.41051945,12.1005862 L2.81888573,6.60290917 C1.29389472,9.6713801 1.92930764,13.5069688 4.47095933,16.0640279 C6.88552844,18.493234 10.3167582,19.1324988 13.2396577,17.9818222 L24.8041728,29.6164411 C25.3125032,30.127853 26.0749987,30.127853 26.583329,29.6164411 L29.5062285,26.6758232 C30.1416414,26.1644113 30.1416414,25.2694407 29.6333111,24.8858818 Z",
    id: "Shape"
  })));
};

module.exports = HandymanIcon;
